import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getCastGroups() {
    return axiosIns.get('/waiter/cast_groups')
  },

  createCastGroup({ name, position }) {
    return axiosIns.post('/waiter/cast_groups', snakecaseKeys({
      castGroup: { name, position },
    }))
  },

  updateCastGroup(id, { name, position }) {
    return axiosIns.put(`/waiter/cast_groups/${id}`, snakecaseKeys({
      castGroup: { name, position },
    }))
  },

  deleteCastGroup(id) {
    return axiosIns.delete(`/waiter/cast_groups/${id}`)
  },
}
